<stp-test-site-banner></stp-test-site-banner>
<router-outlet></router-outlet>